import React from 'react';

const WhatsNewNotification = ({ changes, isVisible, onClose, lastVisit }) => {
  if (!isVisible || !changes) return null;

  const getCurrentUserId = () => window.wwoofBooking?.currentUserId;

  const getOtherPartyName = (booking) => {
    const currentUserId = getCurrentUserId();
    return booking.host_id === currentUserId ? booking.wwoofer_name : booking.host_name;
  };

  const formatDateRange = (start, end) => {
    return `${new Date(start).toLocaleDateString()} - ${new Date(end).toLocaleDateString()}`;
  };

  const formatTimeAgo = (dateString) => {
    // Parse as UTC to avoid timezone issues
    // The dateString is in format 'YYYY-MM-DD HH:MM:SS' and is UTC
    const date = new Date(dateString + ' UTC');
    const now = new Date();
    const diffInMinutes = Math.floor((now - date) / (1000 * 60));
    
    if (diffInMinutes < 1) {
      return 'just now';
    }
    
    if (diffInMinutes < 60) {
      return `${diffInMinutes} minute${diffInMinutes !== 1 ? 's' : ''} ago`;
    }
    
    const diffInHours = Math.floor(diffInMinutes / 60);
    if (diffInHours < 24) {
      return `${diffInHours} hour${diffInHours !== 1 ? 's' : ''} ago`;
    }
    
    const diffInDays = Math.floor(diffInHours / 24);
    return `${diffInDays} day${diffInDays !== 1 ? 's' : ''} ago`;
  };

  const renderNewBookings = (bookings) => {
    if (!bookings || bookings.length === 0) return null;
    
    return (
      <div className="whats-new-section">
        <h4>🎉 New Booking Request{bookings.length > 1 ? 's' : ''} ({bookings.length})</h4>
        <ul>
          {bookings.slice(0, 3).map(booking => (
            <li key={booking.id}>
              <strong>{getOtherPartyName(booking)}</strong>
              <br />
              <small>{formatDateRange(booking.start_date, booking.end_date)}</small>
            </li>
          ))}
          {bookings.length > 3 && (
            <li><em>...and {bookings.length - 3} more</em></li>
          )}
        </ul>
      </div>
    );
  };

  const renderStatusChanges = (statusChanges) => {
    if (!statusChanges || statusChanges.length === 0) return null;
    
    return (
      <div className="whats-new-section">
        <h4>📋 Status Update{statusChanges.length > 1 ? 's' : ''} ({statusChanges.length})</h4>
        <ul>
          {statusChanges.slice(0, 3).map(booking => (
            <li key={booking.id}>
              <strong>{getOtherPartyName(booking)}</strong> - 
              <span className={`status-${booking.status}`}> {booking.status_label}</span>
              <br />
              <small>{formatDateRange(booking.start_date, booking.end_date)}</small>
            </li>
          ))}
          {statusChanges.length > 3 && (
            <li><em>...and {statusChanges.length - 3} more</em></li>
          )}
        </ul>
      </div>
    );
  };

  const renderDateChanges = (dateChanges) => {
    if (!dateChanges || dateChanges.length === 0) return null;
    
    return (
      <div className="whats-new-section">
        <h4>📅 Date Change{dateChanges.length > 1 ? 's' : ''} ({dateChanges.length})</h4>
        <ul>
          {dateChanges.slice(0, 2).map((change, index) => (
            <li key={index}>
              <strong>{getOtherPartyName(change)}</strong>
              <br />
              <small>Updated to: {formatDateRange(change.start_date, change.end_date)}</small>
            </li>
          ))}
          {dateChanges.length > 2 && (
            <li><em>...and {dateChanges.length - 2} more</em></li>
          )}
        </ul>
      </div>
    );
  };

  const hasAnyChanges = Object.values(changes).some(changeArray => 
    Array.isArray(changeArray) && changeArray.length > 0
  );

  if (!hasAnyChanges) return null;

  return (
    <div className="whats-new-overlay" onClick={onClose}>
      <div className="whats-new-modal" onClick={(e) => e.stopPropagation()}>
        <div className="whats-new-header">
          <h3>✨ What's New Since Your Last Visit</h3>
          <button className="whats-new-close" onClick={onClose}>×</button>
        </div>
        
        <div className="whats-new-content">
          {lastVisit && (
            <p className="last-visit-info">
              Last visited: {formatTimeAgo(lastVisit)}
            </p>
          )}
          
          {renderNewBookings(changes.new_bookings)}
          {renderStatusChanges(changes.status_changes)}
          {renderDateChanges(changes.date_changes)}
        </div>
        
        <div className="whats-new-footer">
          <button className="whats-new-button" onClick={onClose}>
            Got it!
          </button>
        </div>
      </div>
    </div>
  );
};

export default WhatsNewNotification;